import { Tooltip as VuetifyTooltipDirective } from 'vuetify/directives/tooltip';
import type { ObjectDirective } from 'vue';
import { normalizeVTooltipBinding } from './tooltipNonEagerBinding';

/** Директива v-tooltip с дефолтным eager: false (можно явно передать eager: true). */
export const tooltipNonEagerDirective: ObjectDirective = {
    mounted: ((el, binding, vnode, prevVNode) => {
        VuetifyTooltipDirective.mounted?.(
            el,
            normalizeVTooltipBinding(binding),
            vnode,
            // Vue передаёт prevVNode как null; Vuetify ожидает VNode в типах
            prevVNode as unknown as Parameters<
                NonNullable<typeof VuetifyTooltipDirective.mounted>
            >[3],
        );
    }) as ObjectDirective['mounted'],
    updated: ((el, binding, vnode, prevVNode) => {
        VuetifyTooltipDirective.updated?.(
            el,
            normalizeVTooltipBinding(binding),
            vnode,
            prevVNode as unknown as Parameters<
                NonNullable<typeof VuetifyTooltipDirective.updated>
            >[3],
        );
    }) as ObjectDirective['updated'],
    unmounted: VuetifyTooltipDirective.unmounted as ObjectDirective['unmounted'],
};
